<script setup lang="ts">
import SettingsPanel from '@/shared/components/settings/SettingsPanel.vue'
import MenuSettingsControls from '@/features/dashboard/components/MenuSettingsControls.vue'
import { useMenuPreferences } from '@/shared/composables/UseMenuPreferences'

withDefaults(defineProps<{
  /** Render a compact cog-only trigger (used in the sidebar) instead of the labelled button. */
  compact?: boolean
}>(), {
  compact: false,
})

const { reset } = useMenuPreferences()
</script>

<template>
  <SettingsPanel title="Stel je menu samen" show-reset @reset="reset">
    <template v-if="compact" #trigger="{ toggle }">
      <Button
        type="button"
        text
        rounded
        severity="secondary"
        icon="fa-regular fa-gear"
        aria-label="Stel je menu samen"
        @click="toggle"
      />
    </template>

    <MenuSettingsControls />
  </SettingsPanel>
</template>
